import './MyMatches.scss';

import { useLocation, useNavigate } from '@reach/router';
import { Pagination } from 'antd';
import React from 'react';

import LoaderComponent from '../../../../../../components/LoaderCompoment/LoaderComponent';
import { useGetMatches } from '../../../../../../core/APIHooks/useGetMatches';
import { FavouriteProfile } from '../MyFavorites/components/FavouriteProfile';

const MyMatches = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const perPage = 30;
  const { data, isLoading } = useGetMatches(query.get('page'), perPage);

  const scrollToTop = () => {
    var elmnt = document.getElementById('scrollTop');
    elmnt.scrollIntoView({ behavior: 'smooth' });
  };

  const handleQuery = (param, value) => {
    param !== 'page' && query.set('page', '1');
    value === 1 ? query.delete(param) : query.set(param, value);
    value === 1
      ? navigate(`${location.pathname}`)
      : navigate(`${location.pathname}?${query.toString()}`);
    scrollToTop();
  };

  const renderProfiles = () => {
    return data?.data.length > 0 ? (
      <div className="ProfilesGridContainer">
        {data.data.map((item) => (
          <FavouriteProfile item={item} key={item.id} />
        ))}
      </div>
    ) : (
      <div className="EmptyArray">You don`t have matches yet</div>
    );
  };

  return (
    <div className="MyMatches">
      <div className="MyMatchesTitle"> My Matches </div>
      {isLoading ? (
        <div className="Loading">
          <LoaderComponent />
        </div>
      ) : (
        <>
          {renderProfiles()}
          <Pagination
            className={'favouritePagination'}
            defaultCurrent={1}
            current={data?.meta.current_page}
            total={data?.meta.total}
            pageSize={perPage}
            onChange={(page) => handleQuery('page', page)}
            showSizeChanger={false}
            hideOnSinglePage={true}
          />
        </>
      )}
    </div>
  );
};

export default MyMatches;
